export function parseDomain(url: string): string {
    return url.split('.').slice(-2).join('.');
}
